const state = {
  key: 0,
};

const mutations = {
  setKey: st => {
    st.key = st.key > 100 ? 0 : (st.key += 1);
  },
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/uniqueKey.js